import "@fontsource/inter";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./theme/theme";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./AppRoutes/AppRoutes";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/es-mx";
// Use localforage if need localStorage

const App = () => {
  return <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es-mx">
          <AppRoutes />
        </LocalizationProvider>
      </BrowserRouter>
    </ThemeProvider>;
};
export default App;